import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  tooltipWrapper: () => ({
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '99999'
  }),
  tooltip: (props) => ({
    position: 'absolute',
    opacity: '0.5',
    bottom: 'auto',
    top: `calc(100% + ${props.arrowSize + props.offset}px)`,
    left: '50%',
    transform: 'translateX(-50%) scale(0)',
    transition: `transform ${theme.speed.normal}ms ease-in-out, opacity ${theme.speed.normal}ms ease-in-out`,
    transformOrigin: 'top',
    backgroundColor: theme.colors[props.backgroundColor].normal,
    width: '80vw',
    '&.right': {
      left: 'auto',
      right: `-${props.arrowSize + props.offset}px`,
      bottom: 'auto',
      top: '50%',
      transform: 'translate(100%, -50%) scale(0)',
      transformOrigin: 'left center',

      '&.visible': {
        transform: 'translate(100%, -50%) scale(1)',
      },
    },
    '&.left': {
      left: `-${props.arrowSize + props.offset}px`,
      right: 'auto',
      bottom: 'auto',
      top: '50%',
      transform: 'translate(-100%, -50%) scale(0)',
      transformOrigin: 'right center',

      '&.visible': {
        transform: 'translate(-100%, -50%) scale(1)',
      },
    },
    '&.top': {
      top: 'auto',
      bottom: `calc(100% + ${props.arrowSize + props.offset}px)`,
      transform: 'translateX(-50%) scale(0)',
      transformOrigin: 'bottom center',
    },
    '&.visible': {
      transform: 'translateX(-50%) scale(1)',
      opacity: '1',
    },

    '&:after': {
      content: '""',
      position: 'absolute',
      right: `calc(50% - ${props.arrowSize}px)`,
      bottom: `calc(50% - ${props.arrowSize}px)`,
      ...({ [props.position]: `calc(100% - ${(props.arrowSize + 2)}px)` }),
      width: props.arrowSize * 2,
      height: props.arrowSize * 2,
      borderRadius: '3px',
      transform: 'rotate(45deg)',
      backgroundColor: theme.colors[props.backgroundColor].normal,
      zIndex: '-1',
    },
  }),
}));

export default useStyle;
